const MenuColors = {
  BLACK: 'Black',
  WHITE: 'White',
};

module.exports = MenuColors;
